// Lib
import { connect } from 'react-redux';

/**
 * TAKEN FROM: https://gist.github.com/andersfly/25ab13dbd1acc5eb915f
 * Detects drag modifier keys on drag events that originated
 * from the wrapped component
 *
 * @param {boolean} options.listenForAllDragEvents
 *   if true it will detect modifier keys for all drag events, and not
 *   just the ones originating from the wrapped component
 */
import { pick } from 'lodash';
import React from 'react';

import PropTypes from 'prop-types';

// Actions
import { setDragModifierKeys } from './dragModifierKeysActions';

// Constants
import { MODIFIER_KEYS_NAMES } from './dragModifierKeysConstants';

// All false
const initialDragModifierKeys = MODIFIER_KEYS_NAMES.reduce((mem, key) => {
    mem[key] = false;
    return mem;
}, {});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetModifierKeys: (modifierKeys) => dispatch(setDragModifierKeys(modifierKeys)),
});

@connect(null, mapDispatchToProps)
class DragModifierKeysListener extends React.Component {
    constructor(props) {
        super(props);

        this.dragModifierKeys = initialDragModifierKeys;
    }

    componentDidMount(event) {
        window.addEventListener('dragstart', this.onDragStart);
        // The 'drag' event doesn't detect modifier keys in FF for some reason.
        // Therefore we listen for dragover on the window instead, which roughly
        // gives the same result
        window.addEventListener('dragover', this.onDrag);
        window.addEventListener('dragend', this.onDragEnd);
    }

    componentWillUnmount(event) {
        window.removeEventListener('dragstart', this.onDragStart);
        window.removeEventListener('dragover', this.onDrag);
        window.removeEventListener('dragend', this.onDragEnd);
    }

    /* eslint-disable react/sort-comp */
    checkEventModifierKeys = (event) => {
        const hasChanged = Object.keys(this.dragModifierKeys).some((key) => this.dragModifierKeys[key] !== event[key]);

        if (hasChanged) {
            this.dragModifierKeys = pick(event, MODIFIER_KEYS_NAMES);
            this.props.dispatchSetModifierKeys(this.dragModifierKeys);
        }
    };
    /* eslint-enable react/sort-comp */

    onDragStart = this.checkEventModifierKeys;

    onDrag = this.checkEventModifierKeys;

    onDragEnd = () => {
        this.dragModifierKeys = initialDragModifierKeys;
    };

    render() {
        return null;
    }
}

DragModifierKeysListener.propTypes = {
    dispatchSetModifierKeys: PropTypes.func,
};

export default DragModifierKeysListener;
